import { MASTER_FLAG_OPTIONS } from '@/pages/return/rgr11V2/constants'

/**
 * 조회조건 유지(D16, D3 정정) — 이 레포 공통 방식을 쓴다. 전용 훅을 만들지 않는다.
 *
 * 마지막 조회 조건을 메뉴 세션(`MenuStorage.menuOnSession`, sessionStorage `moms_menu_on_session`)·
 * URL 쿼리에 남겨 다른 메뉴를 다녀와도 유지한다(MOMS 공통 UX). 세션은 탭바·LNB 가 링크를 조립할 때
 * 읽는 운반체이고, 복원은 URL 쿼리에서 한다(선례: `pages/inbound/erpInbound/searchQuery.ts`).
 *
 * 유지 대상은 D3 그대로다 — 조회 필터 성격의 값만 싣는다. 반송장·원송장·상품바코드(스캔 입력),
 * 반품번호(1회성 작업 입력), 검수표 편집 중인 행은 싣지 않는다. 이 화면에서 조회 필터에 해당하는
 * 값은 마스터 조회여부·등록센터 둘뿐이다 — 나머지는 스캔·1회성 입력이라 대상이 아니다.
 *
 * 페이지 번호·목록 검색어(D16 이 다른 화면에 요구하는 항목)는 이 화면에 없다. 검수표는 서버
 * 페이징도 클라이언트 목록 검색어도 없는 스캔 누적 표라 대상 자체가 없다.
 *
 * 값 주입 통로 — 둘 다 엔트리(`index.tsx`)의 controlled `useState` 를 뷰의 `wiring.fields`(rgr11MasterFlag·rgr11CenterInput)로
 * 잇는다(D2 의 FilterArea 대상이 아니다 — 필터 폼이 아니라 화면 상단 입력칸이다). 통로가 있으므로 둘 다 저장·복원한다.
 */
export interface Rgr11SearchQuery {
  masterFlag?: 'N' | 'Y'
  centerNm?: string
}

const DEFAULT_MASTER_FLAG: 'N' | 'Y' = 'N'

const isMasterFlag = (value: unknown): value is 'N' | 'Y' => MASTER_FLAG_OPTIONS.some((o) => o.value === value)

/** 화면 상태 → 저장 형태. 기본값과 같으면 키 자체를 빼 쿼리스트링을 짧게 유지한다. */
export const toSearchQuery = (state: { masterFlag: 'N' | 'Y'; centerNm: string }): Rgr11SearchQuery => ({
  ...(state.masterFlag === DEFAULT_MASTER_FLAG ? {} : { masterFlag: state.masterFlag }),
  ...(state.centerNm ? { centerNm: state.centerNm } : {}),
})

export interface RestoredRgr11Search {
  masterFlag: 'N' | 'Y'
  centerNm: string
}

/** 조작된 URL(임의 문자열 등)은 기본값으로 떨어뜨려 화면이 깨지지 않게 한다. */
export const fromSearchQuery = (query: Partial<Rgr11SearchQuery>): RestoredRgr11Search => ({
  masterFlag: isMasterFlag(query.masterFlag) ? query.masterFlag : DEFAULT_MASTER_FLAG,
  centerNm: typeof query.centerNm === 'string' ? query.centerNm : '',
})
